/**
 * Da formato a un mensaje con tokens incrustados.
 *
 * @example
 *
 * // Dado el siguiente mensaje:
 * var msg = 'El campo <TOK1> es inválido.';
 *
 * console.log(formatMessage(msg, {
 *  TOK1: 'nombre',
 * }));
 * // Imprime: El campo nombre es inválido.
 */
export const formatMessage = (
  str: string,
  obj: { [key: string]: string },
): string => {
  let newStr = str;
  Object.entries(obj).forEach(([key, value]) => {
    const placeHolder = `<${key}>`;

    if (newStr?.includes(placeHolder)) {
      newStr = newStr.replace(placeHolder, value ?? '');
    }
  });
  return newStr;
};
